export const SAVING_APPLICATION = 'SAVING_APPLICATION';
export const SET_CURRENT_APPLICATION_STATE = 'SET_CURRENT_APPLICATION_STATE';
export const SET_NEXT_DISABLED = 'SET_NEXT_DISABLED'; // just next disabled
export const SET_NAV_DISABLED = 'SET_NAV_DISABLED'; // back and next disabled
export const SET_PORTFOLIO_MODAL = 'SET_PORTFOLIO_MODAL';
export const SET_PORTFOLIO_PROPERTIES = 'SET_PORTFOLIO_PROPERTIES';
export const SET_VALID_PORTFOLIO_ADDRESSES = 'SET_VALID_PORTFOLIO_ADDRESSES';
export const SET_VIEWING = 'SET_VIEWING';
export const SET_APPLICATION_REVIEW_MODAL = 'SET_APPLICATION_REVIEW_MODAL';
export const VIEW_INCOMPLETE_REVIEW_MODAL = 'VIEW_INCOMPLETE_REVIEW_MODAL';
export const SET_APPLICATION_SUMMARY_MODAL = 'SET_APPLICATION_SUMMARY_MODAL';
export const SET_APPRAISAL_MODAL = 'SET_APPRAISAL_MODAL';
export const SET_DECLINE_OR_RECYCLE_MODAL = 'SET_DECLINE_OR_RECYCLE_MODAL';
export const SET_ROLLBACK_MODAL = 'SET_ROLLBACK_MODAL';
export const SET_CONVERT_TO_LOAN_MODAL = 'SET_CONVERT_TO_LOAN_MODAL';
export const CHANGE_APP_LOANTYPE_MODAL = 'CHANGE_APP_LOANTYPE_MODAL';
export const EDIT_REVIEWER_MODAL = 'EDIT_REVIEWER_MODAL';
export const RESTORE_APPLICATION_MODAL = 'RESTORE_APPLICATION_MODAL';
export const MOVE_PROPERTIES_MODAL = 'MOVE_PROPERTIES_MODAL';
export const AUDIT_HISTORY_MODAL = 'AUDIT_HISTORY_MODAL';
export const PRINCIPAL_SWAP_MODAL = 'PRINCIPAL_SWAP_MODAL';
export const APPLICATION_FILES_MODAL = 'APPLICATION_FILES_MODAL';

export const savingApplication = (saving) => (dispatch) => {
    dispatch({ type: SAVING_APPLICATION, saving });
};
export const setNextDisabled = (disabled) => (dispatch) => {
    dispatch({ type: SET_NEXT_DISABLED, disabled });
};
export const setNavDisabled = (disabled) => (dispatch) => {
    dispatch({ type: SET_NAV_DISABLED, disabled });
};
export const setPortfolioModalOpen = (open) => (dispatch) => {
    dispatch({ type: SET_PORTFOLIO_MODAL, open });
};
export const setPortfolioProperties = (properties) => (dispatch) => {
    dispatch({ type: SET_PORTFOLIO_PROPERTIES, properties });
};
export const setValidPortfolioAddresses = (properties) => (dispatch) => {
    dispatch({ type: SET_VALID_PORTFOLIO_ADDRESSES, properties });
};
export const setCurrentApplicationState = (application) => (dispatch) => {
    dispatch({ type: SET_CURRENT_APPLICATION_STATE, application });
};

// set 'viewing' portion of the state
// created initially to set which property is being viewed,
// however can be re-used for whatever is needed
// example: setViewing({propertyIndex: 3})
export const setViewing = (viewing) => (dispatch) => {
    dispatch({ type: SET_VIEWING, viewing });
};
export const setApplicationReviewModal = (state) => (dispatch) => {
    dispatch({ type: SET_APPLICATION_REVIEW_MODAL, state });
};
export const setIncompleteReviewModal = (state) => (dispatch) => {
    dispatch({ type: VIEW_INCOMPLETE_REVIEW_MODAL, state });
};
export const setApplicationSummaryModal = (state) => (dispatch) => {
    dispatch({ type: SET_APPLICATION_SUMMARY_MODAL, state });
};
export const setAppraisalModal = (state) => (dispatch) => {
    dispatch({ type: SET_APPRAISAL_MODAL, state });
};

export const setDeclineOrRecycleModal = (state) => (dispatch) => {
    dispatch({ type: SET_DECLINE_OR_RECYCLE_MODAL, state });
};

export const setRollbackModal = (state) => (dispatch) => {
    dispatch({ type: SET_ROLLBACK_MODAL, state });
};

export const setConvertToLoanModal = (state) => (dispatch) => {
    dispatch({ type: SET_CONVERT_TO_LOAN_MODAL, state });
};

export const setChangeAppLoanTypeModal = (state) => (dispatch) => {
    dispatch({ type: CHANGE_APP_LOANTYPE_MODAL, state });
};

export const setEditReviewerModal = (state) => (dispatch) => {
    dispatch({ type: EDIT_REVIEWER_MODAL, state });
};

export const setRestoreApplicationModal = (state) => (dispatch) => {
    dispatch({ type: RESTORE_APPLICATION_MODAL, state });
};

export const setMovePropertiesModal = (state) => (dispatch) => {
    dispatch({ type: MOVE_PROPERTIES_MODAL, state });
};

export const setAuditHistoryModal = (state) => (dispatch) => {
    dispatch({ type: AUDIT_HISTORY_MODAL, state });
};

export const setPrincipalSwapModal = (state) => (dispatch) => {
    dispatch({ type: PRINCIPAL_SWAP_MODAL, state });
};

export const setApplicationFilesModal = (state) => (dispatch) => {
    dispatch({ type: APPLICATION_FILES_MODAL, state });
};

export default {
    SAVING_APPLICATION,
    SET_CURRENT_APPLICATION_STATE,
    SET_NEXT_DISABLED,
    SET_NAV_DISABLED,
    SET_PORTFOLIO_MODAL,
    SET_PORTFOLIO_PROPERTIES,
    SET_VALID_PORTFOLIO_ADDRESSES,
    SET_VIEWING,
    SET_APPLICATION_REVIEW_MODAL,
    VIEW_INCOMPLETE_REVIEW_MODAL,
    SET_APPLICATION_SUMMARY_MODAL,
    SET_APPRAISAL_MODAL,
    SET_DECLINE_OR_RECYCLE_MODAL,
    SET_ROLLBACK_MODAL,
    SET_CONVERT_TO_LOAN_MODAL,
    CHANGE_APP_LOANTYPE_MODAL,
    EDIT_REVIEWER_MODAL,
    RESTORE_APPLICATION_MODAL,
    MOVE_PROPERTIES_MODAL,
    AUDIT_HISTORY_MODAL,
    PRINCIPAL_SWAP_MODAL,
    APPLICATION_FILES_MODAL,
    savingApplication,
    setNextDisabled,
    setNavDisabled,
    setPortfolioModalOpen,
    setPortfolioProperties,
    setValidPortfolioAddresses,
    setCurrentApplicationState,
    setViewing,
    setApplicationReviewModal,
    setApplicationSummaryModal,
    setAppraisalModal,
    setDeclineOrRecycleModal,
    setRollbackModal,
    setConvertToLoanModal,
    setChangeAppLoanTypeModal,
    setEditReviewerModal,
    setRestoreApplicationModal,
    setMovePropertiesModal,
    setAuditHistoryModal,
    setPrincipalSwapModal,
    setApplicationFilesModal,
};
